export default {
	//Cho phép biết được mua từ website hay từ app
	BuyFromEnum: {
		Website: 0,
		App: 1,
		None: 2
	},

	/**
	 * Loại sản phẩm
	 */
	SoftwareEnum: {
		Mtax: 0,
		Esign: 1
	},

	/**
	 * Loại đơn hàng
	 */
	OrderTypeEnum: {
		New: 0,
		Upgrade: 1,
		Tranfers: 2
	},

	/**
	 * Phương thức thanh toán
	 */
	PaymentMethod: {
		Visa: 2,
		ATM: 1,
		PaymentProvider: 3,
		Tranfers: 4,
		Paypal: 5,
        JeyPay: 6,
		Free: 100
	},

	/**
	 * Trạng thái thanh toán
	 */
	PaymentStatusEnum: {
		New: 0, //Mới
		Wait: 1, //Chờ thanh toán
		Success: 3, //Đã thanh toán
		Cancel: 4 //Đã hủy
	},

	/**
	 * Trạng thái tài nguyên
	 */
	ResourceStatusEnum: {
		New: 0, //Chưa cấp tài nguyên
		Temp: 1, //Cấp tài nguyên tạm
		ResourceGranted: 2, //Đã cấp tn
		Locked: 3, //Đã khóa
		Cancel: 4, // Đã thu hồi tài nguyên
		Error: 5, //Cấp tn lỗi
		NoResources: 6 //Không cấp tài nguyên
	},

	/**
	 * Các loại mã giảm giá
	 */
	PromotionTypeEnum: {
		PromotionMoney: 1, //giảm giá theo tổng tiền đơn hàng
		PromotionMoneyPecent: 2, //giảm giá theo % đơn hàng
		PromotionMoneyPecentProduct: 3, // giảm giá theo % gói sản phẩm
		PromotionTime: 4, //Tặng tháng sử dụng
		PromotionMoneyProduct: 5 // giảm giá theo tổng tiền của mặt hàng
	},

	/**
	 * Loại tài nguyên cấp trên suman
	 */
	BuyNewOrUpgradeEnum: {
		BuyNew: 0, //Mua mới
		Upgrade: 1, //Nâng cấp
		Extended: 2, //Gia hạn
		Free: 3, //Miễn phí
		Trial: 4, //Dùng thử
		Other: 5, // Loại khác
		ChangeInfo: 6, // Thay đổi thông tin
		BuyMore: 7 // Mua thêm
	},

	/**
	 * Loại gói sản phẩm
	 */
	ProductTypeEnum: {
		Create: 0, //Phí khởi tạo
		Pack: 1, //Gói thông thường
		Usb: 2 //Gói mua usb
	},

	/**
	 * Loại ứng dụng truyền lên order
	 */
	AppTypeEnum: {
		Desktop: 0,
		SaaS: 1,
		All: 2
	},

	/**
	 * Loại thời gian tính
	 */
	TimeTypeEnum: {
		Year: 0,
		Month: 1,
		Day: 2
	},

	/**
	 * Loại giảm giá từ úng dụng
	 */
	TypePromotionEnum: {
		None: 0,
		Suman: 1,
		Partner: 2
	},

	/**
	 * Trạng thái của mã giảm giá
	 */
	PromotionCodeStatusEnum: {
		BrandNew: 0, //Mới
		Used: 1, //Đã sử dụng
		Destroyed: 2 //Đã hủy bỏ
	},

	/**
	 * Loại giảm giá chi tiết
	 */
	PromotionTypeDetailEnum: {
		PromotionPecent: 0, //giảm giá %
		PromotionMoney: 1, //giảm giá số tiền
		PromotionTime: 2, //tặng thời gian sử dụng tỉ lệ theo năm
		PromotionTimeMin: 3 //Thời gian sử dụng loại tặng thời gian tối thiểu
	},

	/**
	 * Các lỗi của luồng mua
	 */
	ErrorCodeOrder: {
		Promotion_Invalid: 101, //Mã KM đã không hợp lệ
		Promotion_TypeOther: 102, //Lỗi áp dụng 2 mã giảm giá khác loại
		Promotion_Used: 103, //Mã KM đã được sử dụng
		Promotion_Destroyed: 104, //Mã KM đã bị hủy
		Promotion_Expired: 105, //Mã KM đã hết hạn
		Promotion_NotEnough: 106, //Không đủ điều kiện áp dụng
		Promotion_PackApplyCode: 107, //1 gói sản phẩm chỉ được áp dụng 1 MGG
		ValidateError: 108, //Lỗi khi update trạng thái mgg
		Captcha_Invalid: 109, //Mã xác thực captcha không chính xác
		Exception: 110, //Lỗi exception không xử lí được thanh toán,
		TaxCodeExist: 111, //Mã số thuế đã mua mtax
		UnsSuccess: 112, //Đặt hàng không thành công
		ExistOrder: 113 //Đơn hàng đã tồn tại
	},
	PromotionTimeTypeEnum: {
		Rate: 0, //Tỷ lệ năm
		Minimum: 1 //tối thiểu tháng
	}
};
